import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { InscricaoService } from '../shared/inscricao.service';
import { DadosInscricao } from '../shared/DadosInscricao';
import { FluxoInscricaoService } from '../shared/fluxoInscricao.service';
import { intersection as _intersection } from 'lodash';
@Component({
  moduleId: module.id.toString(),
  templateUrl: './parcelamento.component.html',
  styleUrls: ['./parcelamento.component.scss'],
})
export class ParcelamentoComponent implements OnInit, OnDestroy {

  dadosInscricao: DadosInscricao = new DadosInscricao({});
  dadosInscricaoSubscription: Subscription;
  parcelamentoSelected: any;
  parcelamentos: any;
  loading: boolean;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fluxoInscricaoService: FluxoInscricaoService,
    private inscricaoService: InscricaoService,
  ) { }

  ngOnInit() {
    this.loading = false;
    this.dadosInscricao = this.fluxoInscricaoService.getDadosInscricao();
    if (this.dadosInscricao.parcelamentos) {
    this.parcelamentos = this.dadosInscricao.parcelamentos.filter(parcelamento => {
        const vinculo = !this.dadosInscricao.candidato.vinculo.length ? ['TODOS'] : this.dadosInscricao.candidato.vinculo;
        const result = _intersection(parcelamento.vinculos, vinculo);
        return result.length && parcelamento;
     });
    }
  }


  ngOnDestroy() {
    if (this.dadosInscricaoSubscription) {
      this.dadosInscricaoSubscription.unsubscribe();
    }
  }

  changeParcelamento() {
    this.fluxoInscricaoService.setDadosInscricao({ parcelamentoSelected: this.parcelamentoSelected });
  }

  voltar() {
    this.fluxoInscricaoService.voltarPasso();
    const rotaAnterior = this.fluxoInscricaoService.rotaAnterior();
    this.router.navigate([`../${rotaAnterior}`], { relativeTo: this.route });
  }

  async onSave() {
    this.loading = true;
    const {
      candidato: pessoa,
      turma: { id: idTurma, turno, anoSem: anoRef },
      curso: { id: idCurso, idCampus },
      parcelamentoSelected: { id: idParcelamento },
    } = this.dadosInscricao;

    delete pessoa.vinculo;

    pessoa.cidade = {
      nome: '',
      uf: {
        nome: '',
        sigla: '',
      },
    };

    const inscricao = {
      turma: {
        idCampus,
        idCurso,
        idParcelamento,
        idTurma: String(idTurma),
        anoRef: String(anoRef),
        turno,
      },
      pessoa,
    };

    try {
      const resultInscricao = await this.inscricaoService.saveInscricao(inscricao).toPromise();
      this.loading = false;
      this.fluxoInscricaoService.proximoPasso({
        parcelamentoSelected: this.parcelamentoSelected,
        inscricao: resultInscricao,
      });
      this.nextStep();
    } catch {
      this.loading = false;
    }

  }


  nextStep() {
    const proximaRota = this.fluxoInscricaoService.proximaRota();
    this.router.navigate([`../${proximaRota}`], { relativeTo: this.route });
  }

}
